// A measurement failure must never change the result of a submitted form.
export default function trackLead(formName, eventName = "generate_lead") {
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, { lead_source: "website", form_name: formName });
    }
  } catch (error) {
    // The request was already received; analytics is optional.
  }
}
